namespace RioERP.Reports {
    export interface InvoiceDetailedReportRow {
        Id?: number;
        InvoiceDate?: string;
        OrderDate?: string;
        Invoicenumber?: string;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        CustomerName?: string;
        EInvoiceTo?: Web.Enums.InvoiceTo;
        FranchiseeName?: string;
        City?: string;
        ProductName?: string;
        OrderNumber?: string;
        FranchiseeDiscountAmount?: number;
        OrderDiscount?: number;
        ProductDiscount?: number;
        TaxCategoryName?: string;
        InvoiceCompanyId?: number;
        Total?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        TotalTax?: number;
        EPaymentStatus?: Web.Enums.PaymentStatus;
        InvoiceId?: number;
        FranchiseeId?: number;
        CustomerId?: number;
    }

    export namespace InvoiceDetailedReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.InvoiceDetailedReport';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            OrderDate = "OrderDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            CustomerName = "CustomerName",
            EInvoiceTo = "EInvoiceTo",
            FranchiseeName = "FranchiseeName",
            City = "City",
            ProductName = "ProductName",
            OrderNumber = "OrderNumber",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            OrderDiscount = "OrderDiscount",
            ProductDiscount = "ProductDiscount",
            TaxCategoryName = "TaxCategoryName",
            InvoiceCompanyId = "InvoiceCompanyId",
            Total = "Total",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax",
            EPaymentStatus = "EPaymentStatus",
            InvoiceId = "InvoiceId",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId"
        }
    }
}
